<template>
  <div class="container">
    <img src="../assets/img/logo.png" alt=""/>
  </div>
</template>

<script>
  import axios from 'axios';

  export default {
    name: 'Splash',
    components: {},
    data () {
      return {};
    },
    created () {
      this.initialize();
      this.$store.commit('setAtLogin');
      setTimeout(() => {
        this.$router.push({'path': '/h/popular/'}, ()=>{});
      }, 1000);
    },
    methods: {
      async initialize () {
        // 色初期化
        this.$store.commit('setColors',[]);

        // 料金計算設定を読み込み
        this.$store.dispatch('setPriceCalculation');

        // 読み込んだステッカーをリセット
        this.$store.commit('setItemNextPageUrl');
        this.$store.commit('resetItems');

        this.$store.commit('setLoading');
        let response = await axios.get(this.item_next_page_url);
        this.$store.commit('addItems', response.data.data);
        this.$store.commit('setItemNextPageUrl', response.data.next_page_url);
        this.$store.commit('resetLoading');
      }
    }
  };
</script>

<style scoped lang="scss">
  .container {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
  }
</style>
